const masterByUid = new Map<string, Uint8Array>();

/** 32 байта для HKDF в режиме «только локально» (только память сессии, без localStorage). */
export function getOrCreateLocalOnlyMasterKey(userId: string): Uint8Array {
  const hit = masterByUid.get(userId);
  if (hit && hit.length === 32) return hit;
  const raw = crypto.getRandomValues(new Uint8Array(32));
  masterByUid.set(userId, raw);
  return raw;
}

export function clearLocalOnlyMasterKeySession(userId: string): void {
  masterByUid.delete(userId);
}
